export default __webpack_public_path__ + "static/media/31.0d1aae50.JPG";